// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

// Components
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import { FormActions, FormActionsItem, Trans } from '../../../components';
import { TxButton, TxButtonMode } from 'texkit-ui/components';

// Actions
import { getLookUpDataAndRenewTXRC } from '../../../reducers/agency/txrc/txrcActions';
import { APP_TRANSACTION_IDS } from '../../../reducers/app/appActions';

// Types
import { AppParamsPropTypes } from '../../../components/common/Forms/LinkServiceLookupForm/LinkServiceLookupForm';

const LinkServiceSuccess = ({ link }) => {
  const dispatch = useDispatch();
  const { agency, userKey, appId, app, linkData: { eligibleForRenewal = false} } = link;

  const goToDashboard = () => {
    dispatch(push(`/agency/${agency.agencySlug}`));
  };

  const handleServiceAction = () => {
    dispatch(
      getLookUpDataAndRenewTXRC({
        appId: app.appId,
        userKeys: app.linkUserKeys.slice(app.linkUserKeys.length - 1),
        transactionId: APP_TRANSACTION_IDS.BASIC_INFO,
      })
    );
  };

  return (
    <>
      <h1 className="h2">
        <Trans
          file={agency.agencySlug}
          id={`${app.appSlug}_LinkService_SuccessTitle`}
        />
      </h1>
      <>
        <p className="link-service-lookup-form-custom">
          <Trans file="LinkService" id="SuccessCustomContent_TXRC_Renew" />
        </p>
        {eligibleForRenewal ? (
          <FormActions>
            <FormActionsItem>
             <ButtonPrimary onClick={handleServiceAction}>
                <Trans file="Labels" id={`${app.appSlug}_ServiceAction`} />
              </ButtonPrimary>
            </FormActionsItem>
            <FormActionsItem>
              <TxButton
                mode={TxButtonMode.Secondary}
                onClick={goToDashboard}
              >
                <Trans file="Labels" id={`${app.appSlug}_ViewTxTDashboard`} />
              </TxButton>
            </FormActionsItem>
          </FormActions>
        ) : (
          <FormActions>
            <FormActionsItem>
              <ButtonPrimary onClick={goToDashboard}>
                <Trans file="Labels" id={`${app.appSlug}_ViewTxTDashboard`} />
              </ButtonPrimary>
            </FormActionsItem>
            <FormActionsItem>
              <TxButton
                mode={TxButtonMode.Secondary}
                 onClick={() => dispatch(push(`/link/lookup/txrclicenserenewal`))}
              >
                <Trans file="Labels" id={`${app.appSlug}_LinkAnother`} />
              </TxButton>
            </FormActionsItem>
          </FormActions>
        )}
      </>
    </>
  );
};

LinkServiceSuccess.propTypes = {
  link: PropTypes.shape({
    params: PropTypes.arrayOf(AppParamsPropTypes),
    agency: PropTypes.object,
    app: PropTypes.object,
    linkData: PropTypes.object,
    success: PropTypes.object,
    relinkData: PropTypes.string,
  }).isRequired,
};

export default LinkServiceSuccess;
